<div class="page-container" *ngIf="config">
    <div class="header-section" *ngIf="config.breadcrumbs || config.pageTitle">
        <lib-breadcrumb *ngIf="config.breadcrumbs" [list]="config.breadcrumbs"></lib-breadcrumb>
        <h2 class="page-title" *ngIf="config.pageTitle">{{ config.pageTitle }}</h2>
    </div>

    <!-- Search Criteria Panel -->
    <div class="content-wrapper">
        <form [formGroup]="searchForm" (ngSubmit)="handleSearch()" class="search-form-card">
            <div class="search-grid">
                <div class="form-item" *ngFor="let field of config.searchFields">
                    <mat-label>{{ field.label }}</mat-label>
                    <mat-form-field appearance="outline" class="full-width" style="margin-bottom: -1.25em;">
                        <input matInput *ngIf="field.type === 'text'" [formControlName]="field.key"
                            (keypress)="allowOnlyValidChars($event)" />
                        <input matInput type="number" *ngIf="field.type === 'number'" [formControlName]="field.key" />

                        <mat-select *ngIf="field.type === 'select'" [formControlName]="field.key">
                            <mat-option *ngFor="let opt of field.options" [value]="opt.value">{{ opt.label
                                }}</mat-option>
                        </mat-select>

                        <ng-container *ngIf="field.type === 'date'">
                            <input matInput [matDatepicker]="picker" [formControlName]="field.key">
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                        </ng-container>

                        <ng-container *ngIf="field.type === 'datetime'">
                            <div style="display: flex; gap: 8px;">
                                <mat-form-field appearance="outline" style="flex: 1; margin-bottom: -1.25em;">
                                    <input matInput [matDatepicker]="dtPickerSearch"
                                        [formControlName]="field.key + '_date'" placeholder="Date">
                                    <mat-datepicker-toggle matSuffix [for]="dtPickerSearch"></mat-datepicker-toggle>
                                    <mat-datepicker #dtPickerSearch></mat-datepicker>
                                </mat-form-field>
                                <mat-form-field appearance="outline" style="flex: 1; margin-bottom: -1.25em;">
                                    <mat-select [formControlName]="field.key + '_time'" placeholder="Time">
                                        <mat-option *ngFor="let t of timeOptions" [value]="t">{{ t }}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </ng-container>
                    </mat-form-field>
                </div>
                <div class="form-actions">
                    <button type="reset" mat-stroked-button color="primary" [disabled]="isLoading"
                        (click)="handleReset()">Reset</button>
                    <button type="submit" mat-flat-button color="primary" [disabled]="isLoading">Search</button>
                </div>
            </div>
        </form>

        <!-- Master Table Panel -->
        <div class="section-container master-table-container">
            <div class="section-header">
                <h3 class="heading">{{ config.masterTable.panelTitle || 'Master Data' }}</h3>
                <div class="action-toolbar">
                    <button mat-button color="primary" *ngIf="config.masterTable.actions.showAdd"
                        [disabled]="isMasterAddMode || isMasterEditMode || isLoading"
                        (click)="handleMasterAdd()"><mat-icon>add</mat-icon> Add</button>
                    <button mat-button color="primary" *ngIf="config.masterTable.actions.showSave"
                        [disabled]="(!isMasterAddMode && !isMasterEditMode && !isDetailAddMode && !isDetailEditMode && !isChildDetailAddMode && !isChildDetailEditMode) || isLoading"
                        (click)="handleMasterSave()"><mat-icon>save</mat-icon> Save</button>
                    <button mat-button color="primary" *ngIf="config.masterTable.actions.showModify"
                        [disabled]="selectedMasterRows.length === 0 || isMasterAddMode || isMasterEditMode || isLoading"
                        (click)="handleMasterModify()"><mat-icon>edit</mat-icon> Modify</button>
                    <button mat-button color="warn" *ngIf="config.masterTable.actions.showDelete"
                        [disabled]="selectedMasterRows.length === 0 || isMasterAddMode || isMasterEditMode || isLoading"
                        (click)="handleMasterDelete()"><mat-icon>delete</mat-icon> Delete</button>
                    <button mat-button color="warn" *ngIf="isMasterAddMode || isMasterEditMode" [disabled]="isLoading"
                        (click)="handleMasterCancel()"><mat-icon>cancel</mat-icon> Cancel</button>
                </div>
            </div>

            <mat-progress-bar *ngIf="isLoading" mode="indeterminate"
                style="position: absolute; top: 0; left: 0; right: 0; z-index: 20;"></mat-progress-bar>
            <div class="responsive-table-wrapper">
                <table mat-table [dataSource]="masterDataSource" matSort class="mat-elevation-z0">

                    <ng-container matColumnDef="select">
                        <th mat-header-cell *matHeaderCellDef class="w-10" mat-sort-header disabled></th>
                        <td mat-cell *matCellDef="let element">
                            <mat-checkbox [checked]="isMasterSelected(element)"
                                [disabled]="isMasterAddMode || isMasterEditMode"
                                (change)="toggleMasterSelection(element, $event.checked)">
                            </mat-checkbox>
                        </td>
                    </ng-container>

                    <ng-container *ngFor="let col of flatMasterColumns" [matColumnDef]="col.key">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            <span *ngIf="col.required" style="color:red">*</span> {{ col.label }}
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <ng-container *ngIf="!isColumnEditable(element, col)">
                                <span *ngIf="col.type !== 'checkbox' && col.type !== 'date'">{{ element[col.key]
                                    }}</span>
                                <span *ngIf="col.type === 'date'">{{ element[col.key] | date:'dd-MMM-yyyy' }}</span>
                                <mat-checkbox *ngIf="col.type === 'checkbox'" [checked]="element[col.key]"
                                    disabled></mat-checkbox>
                            </ng-container>

                            <ng-container *ngIf="isColumnEditable(element, col)">
                                <mat-form-field *ngIf="col.type === 'text'" appearance="outline"
                                    class="dense-form-field" style="margin-bottom: -1em;">
                                    <input matInput [(ngModel)]="element[col.key]"
                                        (keypress)="allowOnlyValidChars($event)"
                                        (ngModelChange)="onMasterFieldChange(element, col.key)">
                                </mat-form-field>
                                <mat-form-field *ngIf="col.type === 'number'" appearance="outline"
                                    class="dense-form-field" style="margin-bottom: -1em;">
                                    <input matInput type="number" [(ngModel)]="element[col.key]">
                                </mat-form-field>
                                <mat-form-field *ngIf="col.type === 'select'" appearance="outline"
                                    class="dense-form-field" style="margin-bottom: -1em;">
                                    <mat-select [(ngModel)]="element[col.key]"
                                        (selectionChange)="onSelectChange($event, element, col)">
                                        <mat-select-trigger>
                                            {{ element[col.key] }}
                                        </mat-select-trigger>
                                        <mat-option *ngFor="let opt of col.options" [value]="opt.value">{{ opt.label
                                            }}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <mat-form-field *ngIf="col.type === 'date'" appearance="outline"
                                    class="dense-form-field" style="margin-bottom: -1em;">
                                    <input matInput [matDatepicker]="pickerM" [(ngModel)]="element[col.key]">
                                    <mat-datepicker-toggle matSuffix [for]="pickerM"></mat-datepicker-toggle>
                                    <mat-datepicker #pickerM></mat-datepicker>
                                </mat-form-field>
                                <mat-checkbox *ngIf="col.type === 'checkbox'"
                                    [(ngModel)]="element[col.key]"></mat-checkbox>
                            </ng-container>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="masterDisplayedColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: masterDisplayedColumns;"
                        [class.selected-row]="isMasterSelected(row)" (click)="onMasterRowClick(row)"></tr>
                </table>
            </div>
        </div>

        <!-- Detail Table Panel -->
        <div class="section-container detail-table-container" *ngIf="masterDataSource.data.length > 0">
            <div class="section-header">
                <h3 class="heading">{{ config.detailTable.panelTitle || 'Detail Data' }} <span
                        *ngIf="singleSelectedMasterRow">- {{ getMasterDisplayName() }}</span></h3>
                <div class="action-toolbar">
                    <button mat-button color="primary" *ngIf="config.detailTable.actions.showAdd"
                        [disabled]="!singleSelectedMasterRow || isLoading"
                        (click)="handleDetailAdd()"><mat-icon>add</mat-icon> Add</button>
                    <button mat-button color="primary" *ngIf="config.detailTable.actions.showSave"
                        [disabled]="(!isDetailAddMode && !isDetailEditMode) || isLoading"
                        (click)="handleDetailSave()"><mat-icon>save</mat-icon> Save</button>
                    <button mat-button color="primary" *ngIf="config.detailTable.actions.showModify"
                        [disabled]="selectedDetailRows.length === 0 || isDetailAddMode || isDetailEditMode || isLoading"
                        (click)="handleDetailModify()"><mat-icon>edit</mat-icon> Modify</button>
                    <button mat-button color="warn" *ngIf="config.detailTable.actions.showDelete"
                        [disabled]="selectedDetailRows.length === 0 || isDetailAddMode || isDetailEditMode || isLoading"
                        (click)="handleDetailDelete()"><mat-icon>delete</mat-icon> Delete</button>
                    <button mat-button color="warn" *ngIf="isDetailAddMode || isDetailEditMode" [disabled]="isLoading"
                        (click)="handleDetailCancel()"><mat-icon>cancel</mat-icon> Cancel</button>
                </div>
            </div>
            <div class="responsive-table-wrapper">
                <table mat-table [dataSource]="detailDataSource" matSort class="mat-elevation-z0">
                    <ng-container matColumnDef="select">
                        <th mat-header-cell *matHeaderCellDef class="w-10" mat-sort-header disabled></th>
                        <td mat-cell *matCellDef="let element">
                            <mat-checkbox [checked]="isDetailSelected(element)"
                                [disabled]="isDetailAddMode || isDetailEditMode"
                                (change)="toggleDetailSelection(element, $event.checked)">
                            </mat-checkbox>
                        </td>
                    </ng-container>

                    <ng-container *ngFor="let col of flatDetailColumns" [matColumnDef]="col.key">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            <span *ngIf="col.required" style="color:red">*</span> {{ col.label }}
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <ng-container *ngIf="!isColumnEditable(element, col)">
                                <span *ngIf="col.type !== 'checkbox' && col.type !== 'date'">{{ element[col.key]
                                    }}</span>
                                <span *ngIf="col.type === 'date'">{{ element[col.key] | date:'dd-MMM-yyyy' }}</span>
                                <mat-checkbox *ngIf="col.type === 'checkbox'" [checked]="element[col.key]"
                                    disabled></mat-checkbox>
                            </ng-container>

                            <ng-container *ngIf="isColumnEditable(element, col)">
                                <mat-form-field *ngIf="col.type === 'text'" appearance="outline"
                                    class="dense-form-field" style="margin-bottom: -1em;">
                                    <input matInput [(ngModel)]="element[col.key]"
                                        (keypress)="allowOnlyValidChars($event)">
                                </mat-form-field>
                                <mat-form-field *ngIf="col.type === 'number'" appearance="outline"
                                    class="dense-form-field" style="margin-bottom: -1em;">
                                    <input matInput type="number" [(ngModel)]="element[col.key]">
                                </mat-form-field>
                                <mat-form-field *ngIf="col.type === 'select'" appearance="outline"
                                    class="dense-form-field" style="margin-bottom: -1em;">
                                    <mat-select [(ngModel)]="element[col.key]"
                                        (selectionChange)="onSelectChange($event, element, col)">
                                        <mat-select-trigger>
                                            {{ element[col.key] }}
                                        </mat-select-trigger>
                                        <mat-option *ngFor="let opt of col.options" [value]="opt.value">{{ opt.label
                                            }}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <mat-form-field *ngIf="col.type === 'date'" appearance="outline"
                                    class="dense-form-field" style="margin-bottom: -1em;">
                                    <input matInput [matDatepicker]="pickerD" [(ngModel)]="element[col.key]">
                                    <mat-datepicker-toggle matSuffix [for]="pickerD"></mat-datepicker-toggle>
                                    <mat-datepicker #pickerD></mat-datepicker>
                                </mat-form-field>
                                <mat-checkbox *ngIf="col.type === 'checkbox'"
                                    [(ngModel)]="element[col.key]"></mat-checkbox>
                            </ng-container>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="detailDisplayedColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: detailDisplayedColumns;"
                        [class.selected-row]="isDetailSelected(row)" (click)="onDetailRowClick(row)"></tr>

                    <tr *matNoDataRow>
                        <td class="mat-cell" [attr.colspan]="detailDisplayedColumns.length"
                            style="text-align: center; padding: 20px;">
                            {{ singleSelectedMasterRow ? 'No data found' : 'Select a record from Master Data to view
                            details' }}
                        </td>
                    </tr>
                </table>
            </div>
        </div>

        <!-- Child Detail Table Panel -->
        <div class="section-container child-detail-table-container"
            *ngIf="config.childDetailTable && detailDataSource.data.length > 0">
            <div class="section-header">
                <h3 class="heading">{{ config.childDetailTable.panelTitle || 'Child Detail Data' }} <span
                        *ngIf="singleSelectedDetailRow">- {{ getDetailDisplayName() }}</span></h3>
                <div class="action-toolbar">
                    <button mat-button color="primary" *ngIf="config.childDetailTable.actions.showAdd"
                        [disabled]="!singleSelectedDetailRow || isLoading"
                        (click)="handleChildDetailAdd()"><mat-icon>add</mat-icon> Add</button>
                    <button mat-button color="primary" *ngIf="config.childDetailTable.actions.showSave"
                        [disabled]="(!isChildDetailAddMode && !isChildDetailEditMode) || isLoading"
                        (click)="handleChildDetailSave()"><mat-icon>save</mat-icon> Save</button>
                    <button mat-button color="primary" *ngIf="config.childDetailTable.actions.showModify"
                        [disabled]="selectedChildDetailRows.length === 0 || isChildDetailAddMode || isChildDetailEditMode || isLoading"
                        (click)="handleChildDetailModify()"><mat-icon>edit</mat-icon> Modify</button>
                    <button mat-button color="warn" *ngIf="config.childDetailTable.actions.showDelete"
                        [disabled]="selectedChildDetailRows.length === 0 || isChildDetailAddMode || isChildDetailEditMode || isLoading"
                        (click)="handleChildDetailDelete()"><mat-icon>delete</mat-icon> Delete</button>
                    <button mat-button color="warn" *ngIf="isChildDetailAddMode || isChildDetailEditMode"
                        [disabled]="isLoading" (click)="handleChildDetailCancel()"><mat-icon>cancel</mat-icon>
                        Cancel</button>
                </div>
            </div>
            <div class="responsive-table-wrapper">
                <table mat-table [dataSource]="childDetailDataSource" matSort class="mat-elevation-z0">
                    <ng-container matColumnDef="select">
                        <th mat-header-cell *matHeaderCellDef class="w-10" mat-sort-header disabled></th>
                        <td mat-cell *matCellDef="let element">
                            <mat-checkbox [checked]="isChildDetailSelected(element)"
                                [disabled]="isChildDetailAddMode || isChildDetailEditMode"
                                (change)="toggleChildDetailSelection(element, $event.checked)">
                            </mat-checkbox>
                        </td>
                    </ng-container>

                    <ng-container *ngFor="let col of flatChildDetailColumns" [matColumnDef]="col.key">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            <span *ngIf="col.required" style="color:red">*</span> {{ col.label }}
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <ng-container *ngIf="!isColumnEditable(element, col)">
                                <span *ngIf="col.type !== 'checkbox' && col.type !== 'date'">{{ element[col.key]
                                    }}</span>
                                <span *ngIf="col.type === 'date'">{{ element[col.key] | date:'dd-MMM-yyyy' }}</span>
                                <mat-checkbox *ngIf="col.type === 'checkbox'" [checked]="element[col.key]"
                                    disabled></mat-checkbox>
                            </ng-container>

                            <ng-container *ngIf="isColumnEditable(element, col)">
                                <mat-form-field *ngIf="col.type === 'text'" appearance="outline"
                                    class="dense-form-field" style="margin-bottom: -1em;">
                                    <input matInput [(ngModel)]="element[col.key]"
                                        (keypress)="allowOnlyValidChars($event)">
                                </mat-form-field>
                                <mat-form-field *ngIf="col.type === 'number'" appearance="outline"
                                    class="dense-form-field" style="margin-bottom: -1em;">
                                    <input matInput type="number" [(ngModel)]="element[col.key]">
                                </mat-form-field>
                                <mat-form-field *ngIf="col.type === 'select'" appearance="outline"
                                    class="dense-form-field" style="margin-bottom: -1em;">
                                    <mat-select [(ngModel)]="element[col.key]"
                                        (selectionChange)="onSelectChange($event, element, col)">
                                        <mat-select-trigger>
                                            {{ element[col.key] }}
                                        </mat-select-trigger>
                                        <mat-option *ngFor="let opt of col.options" [value]="opt.value">{{ opt.label
                                            }}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <mat-form-field *ngIf="col.type === 'date'" appearance="outline"
                                    class="dense-form-field" style="margin-bottom: -1em;">
                                    <input matInput [matDatepicker]="pickerCD" [(ngModel)]="element[col.key]">
                                    <mat-datepicker-toggle matSuffix [for]="pickerCD"></mat-datepicker-toggle>
                                    <mat-datepicker #pickerCD></mat-datepicker>
                                </mat-form-field>
                                <mat-checkbox *ngIf="col.type === 'checkbox'"
                                    [(ngModel)]="element[col.key]"></mat-checkbox>
                            </ng-container>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="childDetailDisplayedColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: childDetailDisplayedColumns;"
                        [class.selected-row]="isChildDetailSelected(row)"></tr>

                    <tr *matNoDataRow>
                        <td class="mat-cell" [attr.colspan]="childDetailDisplayedColumns.length"
                            style="text-align: center; padding: 20px;">
                            {{ singleSelectedDetailRow ? 'No data found' : 'Select a record from Detail Data to view
                            child details' }}
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </div>